import appStarterFactory from 'bundles/page/lib/appStarterFactory';
import appEnv from 'bundles/series-description-page/appEnv';

export default appStarterFactory(appEnv);
